import { TWAction } from './widget/widget';
import { EStatus, IBody, IMutableWidgetsMap, TInitPayerOptions, TRequestOptions } from './store';
import { IJson } from './json';

export type TFetchJsonContext<TData = unknown, TOptions = unknown> = {
    currentPageId: string;
    mutableWidgetsMap: IMutableWidgetsMap<TData, TOptions>;
    setPlayerState: (status: EStatus) => void;
};

export type TFetchJson = <TData, TOptions>(
    action: TWAction | undefined,
    context: TFetchJsonContext<TData, TOptions>,
    options?: TRequestOptions,
) => Promise<IJson> | never;

export type TGetBody = <TData, TOptions>(
    action?: TWAction,
    currentPageId?: string,
    mutableWidgetsMap?: IMutableWidgetsMap<TData, TOptions>,
    playerId?: string,
    initPayerOptions?: TInitPayerOptions,
) => Promise<IBody>;
